import { getWrappedWorker } from "../util/getWrappedWorker";
import { buildWindowData } from "owa-worker-shared";
import { logStartGreyError } from "owa-analytics-start";
import { INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT } from "owa-analytics-types";

export function precompileSchema(): void {
    const worker = getWrappedWorker();
    if (worker?.client) {
        const windowData = buildWindowData(false /* includeLocalStorage */);
        worker.client.precompileSchema(windowData).catch(precompileError => {
            logStartGreyError("DataWorkerPrecompileError", 
            /* eslint-disable-next-line owa-custom-rules/telemetry-no-global-account-routing -- (https://aka.ms/OWALintWiki)
             * Justification: precompileSchema runs as part of `workerOptions.preload`, before
             * state initialization. The AccountSourceListStore is not guaranteed to be
             * initialized when this catch handler fires, so no MailboxInfo is obtainable. */
            INTERNAL_ONLY_SYSTEM_METADATA_GLOBAL_ACCOUNT, precompileError);
        });
    }
}
